const TaskTooltip = function($containerEl)
{
    Tooltip.call(this, $containerEl);
};

TaskTooltip.prototype = _.create(Tooltip.prototype, {
    html: "<div id='viewTTPageDetailsTableTaskTooltip' class='viewTTPageDetailsTableTaskTooltip noprint'><%-labelText%></div>",

    messageKeys: function()
    {
        return {
            labelText: "common.tooltip.not_assigned_task"
        };
    }
});


TaskTooltip.getInstance = function()
{
    if (!this._instance)
        this._instance = new this($("body")).init();
    return this._instance;
};

export default TaskTooltip


// WEBPACK FOOTER //
// ./web/js/user/viewtt/detailsTable/TaskTooltip.js